import useMutation from "src/hooks/useMutation";

function useProductRemove(id) {
  return useMutation({
    path: `/api/v1/products/${id}`,
    method: "DELETE",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/products`,
      shouldRevalidate: true,
    },
  });
}

export default useProductRemove;
